import React, { useState } from 'react';

const inputStyle = { width: '100%', background: 'rgba(8,8,8,0.5)', border: '1px solid rgba(245,240,232,0.12)', color: 'var(--white)', padding: '14px 16px', fontFamily: 'var(--font-body)', fontSize: 14, outline: 'none', transition: 'border-color 0.3s', marginBottom: 12 };
const labelStyle = { display: 'block', fontSize: 10, letterSpacing: '0.25em', textTransform: 'uppercase', color: 'rgba(245,240,232,0.45)', marginBottom: 8 };

function scrollTo(id) { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth' }); }

function VolunteerForm() {
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', phone: '', city: '', role: '', 'bot-field': '' });
  const [submitted, setSubmitted] = useState(false);
  const set = k => e => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = new URLSearchParams({ 'form-name': 'volunteer', ...form });
    await fetch('/', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
    setSubmitted(true);
  };

  if (submitted) return (
    <div style={{ padding: '32px', border: '1px solid rgba(200,68,10,0.3)', textAlign: 'center', marginTop: 24 }}>
      <div style={{ fontFamily: 'var(--font-display)', fontSize: 36, color: 'var(--ember)', marginBottom: 8 }}>YOU'RE ON THE TEAM.</div>
      <p style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 16, color: 'rgba(245,240,232,0.55)' }}>We'll reach out with your city's serving details.</p>
    </div>
  );

  return (
    <form onSubmit={handleSubmit} name="volunteer" data-netlify="true" netlify-honeypot="bot-field" id="volunteer-form" style={{ marginTop: 24 }}>
      <input type="hidden" name="form-name" value="volunteer" />
      <input type="hidden" name="bot-field" value={form['bot-field']} />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 0 }}>
        <div><label style={labelStyle}>First Name</label><input required value={form.firstName} onChange={set('firstName')} placeholder="First name" style={inputStyle} /></div>
        <div><label style={labelStyle}>Last Name</label><input required value={form.lastName} onChange={set('lastName')} placeholder="Last name" style={inputStyle} /></div>
      </div>
      <label style={labelStyle}>Email</label>
      <input required type="email" value={form.email} onChange={set('email')} placeholder="your@email.com" style={inputStyle} />
      <label style={labelStyle}>City You Want To Serve In</label>
      <select required value={form.city} onChange={set('city')} style={{ ...inputStyle, appearance: 'none', background: 'rgba(8,8,8,0.8)', color: form.city ? 'var(--white)' : 'rgba(245,240,232,0.35)' }}>
        <option value="" disabled>Select city</option>
        {['Los Angeles','Dallas','San Francisco','Hawaii','Louisiana','Colorado','Atlanta'].map(c => <option key={c}>{c}</option>)}
      </select>
      <label style={labelStyle}>Preferred Role</label>
      <select value={form.role} onChange={set('role')} style={{ ...inputStyle, appearance: 'none', background: 'rgba(8,8,8,0.8)', color: form.role ? 'var(--white)' : 'rgba(245,240,232,0.35)' }}>
        <option value="">Select a role</option>
        {['Welcome / Ushering','Prayer Team','Media / Livestream','Worship Support','Setup / Teardown','First-Timers Follow-up','Open to Any Role'].map(r => <option key={r}>{r}</option>)}
      </select>
      <button type="submit" style={{ width: '100%', background: 'var(--ember)', color: 'var(--white)', border: 'none', padding: '16px', fontFamily: 'var(--font-body)', fontSize: 12, fontWeight: 500, letterSpacing: '0.2em', textTransform: 'uppercase', marginTop: 4 }}
        onMouseEnter={e => e.target.style.background = 'var(--ember-light)'}
        onMouseLeave={e => e.target.style.background = 'var(--ember)'}>
        Register To Serve
      </button>
    </form>
  );
}

function PartnerForm() {
  const [form, setForm] = useState({ name: '', email: '', organization: '', partnerType: '', message: '', 'bot-field': '' });
  const [submitted, setSubmitted] = useState(false);
  const set = k => e => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = new URLSearchParams({ 'form-name': 'partner', ...form });
    await fetch('/', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
    setSubmitted(true);
  };

  if (submitted) return (
    <div style={{ padding: '32px', border: '1px solid rgba(212,168,67,0.3)', textAlign: 'center', marginTop: 24 }}>
      <div style={{ fontFamily: 'var(--font-display)', fontSize: 36, color: 'var(--gold)', marginBottom: 8 }}>THANK YOU, PARTNER.</div>
      <p style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 16, color: 'rgba(245,240,232,0.55)' }}>You helped bring a city to REVIVE. We'll be in touch.</p>
    </div>
  );

  return (
    <form onSubmit={handleSubmit} name="partner" data-netlify="true" netlify-honeypot="bot-field" style={{ marginTop: 24 }}>
      <input type="hidden" name="form-name" value="partner" />
      <input type="hidden" name="bot-field" value={form['bot-field']} />
      <label style={labelStyle}>Full Name</label>
      <input required value={form.name} onChange={set('name')} placeholder="Your name" style={inputStyle} />
      <label style={labelStyle}>Email</label>
      <input required type="email" value={form.email} onChange={set('email')} placeholder="your@email.com" style={inputStyle} />
      <label style={labelStyle}>Organization / Ministry (optional)</label>
      <input value={form.organization} onChange={set('organization')} placeholder="Church, ministry, or organization" style={inputStyle} />
      <label style={labelStyle}>Partnership Type</label>
      <select value={form.partnerType} onChange={set('partnerType')} style={{ ...inputStyle, appearance: 'none', background: 'rgba(8,8,8,0.8)', color: form.partnerType ? 'var(--white)' : 'rgba(245,240,232,0.35)' }}>
        <option value="">Select one</option>
        {['Financial Partner','Ministry / Church Partner','Christian Influencer / Content Creator','Media Partner','Bring a Group','Other'].map(o => <option key={o}>{o}</option>)}
      </select>
      <label style={labelStyle}>Message (optional)</label>
      <textarea value={form.message} onChange={set('message')} placeholder="Tell us about your interest..." rows={3}
        style={{ ...inputStyle, resize: 'vertical' }} />
      <p style={{ fontSize: 12, color: 'rgba(245,240,232,0.35)', marginBottom: 12 }}>
        Give via Zelle: <strong style={{ color: 'var(--gold)' }}>gc.boundlessgroup@gmail.com</strong>
      </p>
      <button type="submit" style={{ width: '100%', background: 'transparent', color: 'var(--white)', border: '1px solid rgba(245,240,232,0.25)', padding: '16px', fontFamily: 'var(--font-body)', fontSize: 12, fontWeight: 400, letterSpacing: '0.2em', textTransform: 'uppercase' }}
        onMouseEnter={e => { e.target.style.borderColor = 'var(--gold)'; e.target.style.color = 'var(--gold)'; }}
        onMouseLeave={e => { e.target.style.borderColor = 'rgba(245,240,232,0.25)'; e.target.style.color = 'var(--white)'; }}>
        Partner With REVIVE
      </button>
    </form>
  );
}

export default function GetInvolved() {
  const [activeTab, setActiveTab] = useState('volunteer');

  return (
    <section id="get-involved" style={{ background: 'var(--ash)', padding: '120px 64px' }}>
      <style>{`
        @media(max-width:900px){ #get-involved{padding:80px 24px!important;} .involved-grid{grid-template-columns:1fr!important;} }
      `}</style>

      <p className="reveal" style={{ fontSize: 10, letterSpacing: '0.35em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 20 }}>Join The Work</p>
      <h2 className="reveal" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(48px,6vw,80px)', lineHeight: 0.95, color: 'var(--white)', marginBottom: 24 }}>
        GET<br />INVOLVED
      </h2>
      <div className="reveal" style={{ width: 48, height: 3, background: 'linear-gradient(90deg,var(--ember),var(--gold))', margin: '0 0 64px' }} />

      <div className="involved-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        {/* Volunteer card */}
        <div className="reveal" style={{ padding: '48px 40px', border: '1px solid rgba(200,68,10,0.15)', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 20, right: 28, fontFamily: 'var(--font-display)', fontSize: 80, color: 'rgba(200,68,10,0.06)', lineHeight: 1 }}>01</div>
          <div style={{ fontSize: 28, marginBottom: 20 }}>⚡</div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 32, letterSpacing: '0.05em', color: 'var(--white)', marginBottom: 12 }}>VOLUNTEER</div>
          <p style={{ fontSize: 14, color: 'rgba(245,240,232,0.5)', lineHeight: 1.7, marginBottom: 0 }}>
            REVIVE runs on the backs of people who show up. We need ushers, welcome teams, media crews, prayer teams, and more in every city.
          </p>
          <VolunteerForm />
        </div>

        {/* Partner card */}
        <div className="reveal reveal-d2" style={{ padding: '48px 40px', border: '1px solid rgba(200,68,10,0.15)', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 20, right: 28, fontFamily: 'var(--font-display)', fontSize: 80, color: 'rgba(200,68,10,0.06)', lineHeight: 1 }}>02</div>
          <div style={{ fontSize: 28, marginBottom: 20 }}>🔥</div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 32, letterSpacing: '0.05em', color: 'var(--white)', marginBottom: 12 }}>PARTNER WITH US</div>
          <p style={{ fontSize: 14, color: 'rgba(245,240,232,0.5)', lineHeight: 1.7, marginBottom: 0 }}>
            REVIVE is free because partners make it possible. Every dollar goes directly to bringing this movement to another city. Sow into the harvest.
          </p>
          <PartnerForm />
        </div>

        {/* Bring your people */}
        <div className="reveal reveal-d1" style={{ padding: '48px 40px', border: '1px solid rgba(200,68,10,0.15)', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 20, right: 28, fontFamily: 'var(--font-display)', fontSize: 80, color: 'rgba(200,68,10,0.06)', lineHeight: 1 }}>03</div>
          <div style={{ fontSize: 28, marginBottom: 20 }}>📣</div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 32, letterSpacing: '0.05em', color: 'var(--white)', marginBottom: 12 }}>BRING YOUR PEOPLE</div>
          <p style={{ fontSize: 14, color: 'rgba(245,240,232,0.5)', lineHeight: 1.7, marginBottom: 32 }}>
            Ministry leaders, campus pastors, cell group leaders — bring your community. Contact us about group registration and how we can work with your ministry.
          </p>
          <button onClick={() => scrollTo('register')} style={{ background: 'transparent', color: 'var(--white)', border: '1px solid rgba(245,240,232,0.25)', padding: '14px 32px', fontFamily: 'var(--font-body)', fontSize: 12, letterSpacing: '0.2em', textTransform: 'uppercase' }}
            onMouseEnter={e => { e.target.style.borderColor = 'var(--ember)'; e.target.style.color = 'var(--ember)'; }}
            onMouseLeave={e => { e.target.style.borderColor = 'rgba(245,240,232,0.25)'; e.target.style.color = 'var(--white)'; }}>
            Register as Group Leader
          </button>
        </div>

        {/* Pray */}
        <div className="reveal reveal-d3" style={{ padding: '48px 40px', border: '1px solid rgba(200,68,10,0.15)', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 20, right: 28, fontFamily: 'var(--font-display)', fontSize: 80, color: 'rgba(200,68,10,0.06)', lineHeight: 1 }}>04</div>
          <div style={{ fontSize: 28, marginBottom: 20 }}>🙏</div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 32, letterSpacing: '0.05em', color: 'var(--white)', marginBottom: 12 }}>PRAY</div>
          <p style={{ fontSize: 14, color: 'rgba(245,240,232,0.5)', lineHeight: 1.7, marginBottom: 32 }}>
            Join the REVIVE prayer network. Receive weekly city-specific prayer points and intercede for each city before we arrive. The work begins in the place of prayer.
          </p>
          <button onClick={() => scrollTo('prayer')} style={{ background: 'transparent', color: 'var(--white)', border: '1px solid rgba(245,240,232,0.25)', padding: '14px 32px', fontFamily: 'var(--font-body)', fontSize: 12, letterSpacing: '0.2em', textTransform: 'uppercase' }}
            onMouseEnter={e => { e.target.style.borderColor = 'var(--gold)'; e.target.style.color = 'var(--gold)'; }}
            onMouseLeave={e => { e.target.style.borderColor = 'rgba(245,240,232,0.25)'; e.target.style.color = 'var(--white)'; }}>
            Submit A Prayer
          </button>
        </div>
      </div>
    </section>
  );
}
